import { STAFF_TENANT_SLUG } from "@/lib/product-roles";
export function authRole(me) {
    return me?.product_roles?.signaris_auth;
}
export function isSuperadmin(me) {
    return authRole(me) === "superadmin";
}
/** Админ организации или суперадмин — полный доступ к админке. */
export function isAuthAdmin(me) {
    const r = authRole(me);
    return r === "admin" || r === "superadmin";
}
/** Кадровик без прав администратора: на него действуют гарды `hr_only`. */
export function isHrOnly(me) {
    return authRole(me) === "hr";
}
/** Сотрудники, приглашения, кадровые данные, оргструктура. */
export function canManageHr(me) {
    return isAuthAdmin(me) || isHrOnly(me);
}
/** Штат Signaris: суперадмин или admin организации штата (кросс-тенантные операции). */
export function isStaff(me) {
    return isSuperadmin(me) || (authRole(me) === "admin" && me?.tenant_slug === STAFF_TENANT_SLUG);
}
/** Оргструктура — только организациям с Hub (кадровые данные — модель доступа Hub). */
export function hasOrgStructure(me) {
    return canManageHr(me) && (isSuperadmin(me) || (me?.tenant_purchased_products ?? []).includes("hub"));
}
